import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { SELECTED_TOTAL_VALUES } from 'api/query-keys.ts';
import type { SelectedTotalValuesRes } from 'api/swagger';

interface IParams {
  cargoIds?: number[];
  cargoItemIds?: number[];
  isEnabled: boolean;
}

export const useGetSelectedTotalValues = (params: IParams) => {
  const { cargoIds, cargoItemIds, isEnabled } = params;

  return useQuery<SelectedTotalValuesRes>({
    queryKey: [SELECTED_TOTAL_VALUES],
    queryFn: async () => {
      const { data } = await http.post<SelectedTotalValuesRes>(`/v1/calculate/selected-total-values`, {
        cargoIds,
        cargoItemIds,
      });

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: isEnabled,
    staleTime: 0,
    cacheTime: 0,
  });
};
